import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <div className="text-5xl font-semibold text-ducens-muted mb-3">404</div>
        <h1 className="text-xl font-semibold mb-2">Page introuvable</h1>
        <p className="text-sm text-ducens-muted mb-4">
          La page que tu cherches n'existe pas ou a été déplacée.
        </p>
        <Link
          to="/"
          className="inline-block px-4 py-2 rounded-md bg-ducens-ink text-white text-sm hover:opacity-90"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
